import { Injectable, Injector } from '@angular/core';
import { BrowserControlService } from '../../../cross-team-shared/misc-services/browser-control.service';
import { MouseEventInfo } from '../../../cross-team-shared/misc-services/events/mouse-event.service';
import { EventTrackingValue } from '../../../team-apis/core/event-tracking';
import { isCuboidHelper } from '../../render/mesh/mesh-utils';
import { PointCloudToolName } from '../../state/point-cloud-content-state';
import { deleteIfDefined } from '../../state/render-state';
import { AbstractPointCloudTool } from '../abstract-point-cloud-tool';

@Injectable()
export class SelectTool3D extends AbstractPointCloudTool {
  readonly name: PointCloudToolName = 'Select';

  private browserControlService: BrowserControlService;

  constructor(injector: Injector) {
    super(injector);
    this.browserControlService = injector.get(BrowserControlService);
  }

  override async onActivate() {
    await super.onActivate();

    this.onEvent('container', 'click', this.onContainerClick);
    this.onEvent('container', 'click', this.onContainerClick, {
      modifiers: ['platform'],
    });
    this.onEvent('container', 'dblclick', this.onContainerDoubleClick);
  }

  override onCancel(eventTrackingValue: EventTrackingValue) {
    super.onCancel(eventTrackingValue);

    // Using .setUsing(deleteIfDefined), since .delete makes the parent store
    // emits even if the last value was undefined
    this.store('render')('highlightedShapeIndex').setUsing(deleteIfDefined);
  }

  protected onContainerDoubleClick(_event: MouseEvent) {
    const shape = this.rayCastService.getIntersectingShape();
    if (shape && isCuboidHelper(shape)) {
      this.shellConnector.scopeObject(shape.index);
    }
  }

  protected onContainerClick(
    event: MouseEvent,
    _eventInfo: MouseEventInfo,
    source = 'select_tool_3d',
  ) {
    const shape = this.rayCastService.getIntersectingShape();
    const modifierDown =
      event[this.browserControlService.getPlatformModifier()];

    if (shape) {
      this.shellConnector.modifyShapeSelection(
        [shape.index],
        modifierDown ? 'toggle' : 'set',
        { source },
      );
    } else {
      if (!modifierDown) {
        this.shellConnector.modifyShapeSelection([], 'set', { source });
      }
    }
  }

  protected override onContainerMouseMove(event: MouseEvent) {
    super.onContainerMouseMove(event);
    this.highlightCuboid(event.shiftKey);
  }

  private highlightCuboid(shiftKey: boolean) {
    const shapeHelper = this.rayCastService.getIntersectingShape(
      this.store.state().mouse.containerPoint,
      shiftKey,
    );

    this.store('render')('highlightedShapeIndex').set(shapeHelper?.index);
  }
}
